/* eslint-disable array-callback-return */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-undef */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React, {
    useState, useCallback, useRef, useEffect,
} from 'react';
import moment from 'moment';
import Checkbox from 'react-custom-checkbox';
import * as Icon from 'react-icons/fi';
import { Calendar } from 'react-calendar';
import { createUrl } from '../../redux/helper/CreateQuery';

function FilterModal({
    filterModal, setFilterModal, Filter, setFilter, filterValue, setfilterValue, handleFilter, threeplList, setThreeplList, handleFetchInvoices, selected, setselected, SetSuccessMessage,
}) {
    const dateRef = useRef();
    const dateRef1 = useRef();
    const [selectedType, setselectedType] = useState('invoice_date_range');
    const toggleState = {
        invoice_start_date: false,
        invoice_end_date: false,
        order_start_date: false,
        order_end_date: false,
    };
    const [toggle, settoggle] = useState(toggleState);

    const HandleFilter = useCallback((key, val) => {
        const Filtercopy = { ...Filter };
        const idx = Filtercopy[key].indexOf(val);
        if (idx === -1) {
            Filtercopy[key].push(val);
        } else {
            Filtercopy[key].splice(idx, 1);
        }
        Filtercopy[key];
        setFilter(Filtercopy);
        return idx > -1;
        // return false
    }, []);

    const handleToggle = (key) => {
        settoggle((prevState) => ({
            ...prevState,
            [key]: !toggle[key],
        }));
    };

    const handleDate = (val, key) => {
        const state = key === 'start_date' ? 'end_date' : 'start_date';
        if (key === 'start_date') {
            setselected((prevState) => ({
                ...prevState,
                end_date: '',
            }));
        }
        settoggle(toggleState);
        if (key === 'end_date') {
            settoggle(toggleState);
        } else {
            setTimeout(() => {
                handleToggle(state);
            }, 500);
        }
        setselected((prevState) => ({
            ...prevState,
            [key]: val,
        }));
        if (key === 'end_date') {
            settoggle(toggleState);
        }
    };

    const generateUrl = (val) => {
        let final = '';
        Object.keys(Filter).map((key) => {
            switch (key) {
            case 'order_category':
                if (Filter[key].length > 0) {
                    final += `&order_category=${createUrl(Filter[key])}`;
                }
                break;
            case 'return_status':
                if (Filter[key].length > 0) {
                    final += `&response_status=${createUrl(Filter[key])}`;
                }
                break;
            default: break;
            }
        });
        if (selected.invoice_start_date !== '' && selected.invoice_end_date !== '') {
            final += `&TRX_DATE=${moment(selected.invoice_start_date).format('DD-MM-YYYY')},${moment(selected.invoice_end_date).format('DD-MM-YYYY')}`;
        }
        if (selected.order_start_date !== '' && selected.order_end_date !== '') {
            final += `&ORDER_ACCEPTANCE_DATE=${moment(selected.order_start_date).format('DD-MM-YYYY')},${moment(selected.order_end_date).format('DD-MM-YYYY')}`;
        }
        if (val === undefined) {
            handleFilter(final);
        }
        setFilterModal(false);
        SetSuccessMessage('Filters applied Successfully!');
        setTimeout(() => {
            SetSuccessMessage('');
        }, 2000);
        return final;
    };

    const handleClear = () => {
        setFilter({
            order_category: [],
            return_status: [],
        });
        setselected({
            invoice_start_date: '',
            invoice_end_date: '',
            order_start_date: '',
            order_end_date: '',
        });
        setfilterValue('');
        handleFetchInvoices();
        setFilterModal(false);
        SetSuccessMessage('Filters cleared Successfully!');
        setTimeout(() => {
            SetSuccessMessage('');
        }, 2000);
        return final;
    };

    useEffect(() => {
        const handler = (event) => {
            if (dateRef && !dateRef.current.contains(event.target)) {
                settoggle((prevState) => ({
                    ...prevState,
                    invoice_start_date: false,
                    invoice_end_date: false,
                }));
                // setNotificationDropdown(false)
                // setReportsDropdown(false)
            }
        };
        document.addEventListener('mousedown', handler);

        return () => {
            document.removeEventListener('mousedown', handler);
        };
    }, [dateRef]);

    useEffect(() => {
        const handler = (event) => {
            if (dateRef1 && !dateRef1.current.contains(event.target)) {
                settoggle((prevState) => ({
                    ...prevState,
                    order_start_date: false,
                    order_end_date: false,
                }));
                // setNotificationDropdown(false)
                // setReportsDropdown(false)
            }
        };
        document.addEventListener('mousedown', handler);

        return () => {
            document.removeEventListener('mousedown', handler);
        };
    }, [dateRef1]);

    return (
        <div className={`modal fade fixed top-0 left-0 ${filterModal ? 'show' : 'hidden'} w-full h-full outline-none overflow-x-hidden overflow-y-auto`} id="filtermodal" tabIndex="-1" aria-labelledby="deactivateOfferModal" aria-modal="true" role="dialog">
            <div className="modal-dialog modal-dialog-centered relative w-auto pointer-events-none sm:max-w-[570px] mx-auto px-2.5" style={{ margin: 'auto' }}>
                <div
                    className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current"
                >
                    <div className="modal-header flex flex-shrink-0 items-center justify-between pt-[26px] rounded-t-md">
                        <h5 className="text-lg font-semibold text-[#090406] text-center w-full" id="exampleModalScrollableLabel1">
                            Filter
                        </h5>
                        <button
                            type="button"
                            className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline absolute top-4 right-6"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => setFilterModal(false)}
                        >
                            <img src="/images/close.svg" alt="icon" />
                        </button>
                    </div>
                    <div className="modal-body relative sm:px-5 px-3 sm:pt-5 pt-4 sm:pb-7 pb-5 text-center">
                        <div className="flex items-start">
                            <ul className="nav nav-pills flex flex-col flex-wrap items-start list-none pl-0 w-[40%] h-full" id="pills-tabVertical" role="tablist">
                                <li className="nav-item flex-grow text-start w-full mb-4" role="presentation" onClick={() => setselectedType('invoice_date_range')}>
                                    <a
                                        href="#pills-profileVertical"
                                        className={`nav-link block text-base font-semibold ${selectedType === 'invoice_date_range' ? 'active' : ''} text-[#AAA6AF] order relative w-full`}
                                        id="pills-categories"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pillcategorie"
                                        role="tab"
                                        aria-controls="pillcategorie"
                                        aria-selected="false"
                                    >
                                        Invoice Date Range
                                    </a>
                                </li>
                                <li className="nav-item flex-grow text-start w-full mb-4" role="presentation" onClick={() => setselectedType('order_date_range')}>
                                    <a
                                        href="#pills-profileVertical"
                                        className={`nav-link block text-base font-semibold ${selectedType === 'order_date_range' ? 'active' : ''} text-[#AAA6AF] order relative w-full`}
                                        id="pills-categories"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pillcategorie"
                                        role="tab"
                                        aria-controls="pillcategorie"
                                        aria-selected="false"
                                    >
                                        Order Date Range
                                    </a>
                                </li>
                                <li className="nav-item flex-grow w-full text-start mb-4" role="presentation" onClick={() => setselectedType('order_category')}>
                                    <a
                                        href="#pills-pricetab"
                                        className={`nav-link block text-base ${selectedType === 'order_category' ? 'active' : ''} font-semibold text-[#AAA6AF] order relative w-full`}
                                        id="pills-priceranje"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-pricetab"
                                        role="tab"
                                        aria-controls="pills-price"
                                        aria-selected="true"
                                    >
                                        Order Category
                                    </a>
                                </li>
                                <li className="nav-item flex-grow text-start w-full mb-4" role="presentation" onClick={() => setselectedType('return_status')}>
                                    <a
                                        href="#pills-profileVertical "
                                        className={`nav-link block text-base font-semibold ${selectedType === 'return_status' ? 'active' : ''} text-[#AAA6AF] order relative w-full`}
                                        id="pills-size"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-sizemm"
                                        role="tab"
                                        aria-controls="pills-sizemm"
                                        aria-selected="false"
                                    >
                                        Return Status
                                    </a>
                                </li>

                            </ul>
                            <div className="tab-content w-[75%] h-[230px] border-l border-[#D8D8D8]" id="pills-tabContentVertical">
                                <div className={`tab-pane fade ${selectedType === 'order_category' ? 'show active' : ''} px-3 max-h-[210px] overflow-auto custom-scrollbar`} id="pills-pricetab" role="tabpanel" aria-labelledby="pills-priceranje">
                                    <div className="relative">
                                        <div className="cursor-pointer">
                                            <div className="flex items-center mb-3">
                                                <Checkbox
                                                    icon={
                                                        <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.order_category?.includes('CONSUMABLES') ? '#555259' : ''}` }} />
                                                    }
                                                    name="my-input"
                                                    className="cursor-pointer"
                                                    checked={Filter.order_category.includes('CONSUMABLES')}
                                                    onChange={() => HandleFilter('order_category', 'CONSUMABLES')}
                                                    borderColor={`${Filter.order_category.includes('CONSUMABLES') ? '#B8C5DC' : '#555259'}`}
                                                    style={{ cursor: 'pointer' }}
                                                    labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                                />
                                                <label htmlFor="mn1" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">Consumables</label>
                                            </div>
                                            <div className="flex items-center mb-3">
                                                <Checkbox
                                                    icon={
                                                        <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.order_category?.includes('EQUIPMENTS') ? '#555259' : ''}` }} />
                                                    }
                                                    name="my-input"
                                                    className="cursor-pointer"
                                                    checked={Filter.order_category.includes('EQUIPMENTS')}
                                                    onChange={() => HandleFilter('order_category', 'EQUIPMENTS')}
                                                    borderColor={`${Filter.order_category.includes('EQUIPMENTS') ? '#B8C5DC' : '#555259'}`}
                                                    style={{ cursor: 'pointer' }}
                                                    labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                                />
                                                <label htmlFor="mn2" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">Equipments</label>
                                            </div>
                                            <div className="flex items-center mb-3">
                                                <Checkbox
                                                    icon={
                                                        <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.order_category?.includes('OTHERS') ? '#555259' : ''}` }} />
                                                    }
                                                    name="my-input"
                                                    className="cursor-pointer"
                                                    checked={Filter.order_category.includes('OTHERS')}
                                                    onChange={() => HandleFilter('order_category', 'OTHERS')}
                                                    borderColor={`${Filter.order_category.includes('OTHERS') ? '#B8C5DC' : '#555259'}`}
                                                    style={{ cursor: 'pointer' }}
                                                    labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                                />
                                                <label htmlFor="mn3" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">Others</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className={`tab-pane ${selectedType === 'return_status' ? 'show active' : ''} fade w-full overflow-auto px-3 h-[190px] sidebar`} id="pills-sizemm" role="tabpanel" aria-labelledby="pills-size">
                                    <div className="cursor-pointer">
                                        <div className="flex items-center mb-3">
                                            <Checkbox
                                                icon={
                                                    <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.return_status?.includes('REQUEST FOR RETURN') ? '#555259' : ''}` }} />
                                                }
                                                name="my-input"
                                                className="cursor-pointer"
                                                checked={Filter.return_status.includes('REQUEST FOR RETURN')}
                                                onChange={() => HandleFilter('return_status', 'REQUEST FOR RETURN')}
                                                borderColor={`${Filter.return_status.includes('REQUEST FOR RETURN') ? '#B8C5DC' : '#555259'}`}
                                                style={{ cursor: 'pointer' }}
                                                labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                            />
                                            <label htmlFor="mn4" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">Pending</label>
                                        </div>
                                        <div className="flex items-center mb-3">
                                            <Checkbox
                                                icon={
                                                    <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.return_status?.includes('RETURN REQUEST APPROVED') ? '#555259' : ''}` }} />
                                                }
                                                name="my-input"
                                                className="cursor-pointer"
                                                checked={Filter.return_status.includes('RETURN REQUEST APPROVED')}
                                                onChange={() => HandleFilter('return_status', 'RETURN REQUEST APPROVED')}
                                                borderColor={`${Filter.return_status.includes('RETURN REQUEST APPROVED') ? '#B8C5DC' : '#555259'}`}
                                                style={{ cursor: 'pointer' }}
                                                labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                            />
                                            <label htmlFor="mn5" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">Approved</label>
                                        </div>
                                        <div className="flex items-center mb-3">
                                            <Checkbox
                                                icon={
                                                    <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.return_status?.includes('RETURN REQUEST REJECTED') ? '#555259' : ''}` }} />
                                                }
                                                name="my-input"
                                                className="cursor-pointer"
                                                checked={Filter.return_status.includes('RETURN REQUEST REJECTED')}
                                                onChange={() => HandleFilter('return_status', 'RETURN REQUEST REJECTED')}
                                                borderColor={`${Filter.return_status.includes('RETURN REQUEST REJECTED') ? '#B8C5DC' : '#555259'}`}
                                                style={{ cursor: 'pointer' }}
                                                labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                            />
                                            <label htmlFor="mn6" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">Rejected</label>
                                        </div>
                                    </div>
                                </div>
                                <div ref={dateRef} className={`tab-pane fade  px-3 ${selectedType === 'invoice_date_range' ? 'show active' : ''}`} id="pillcategorie" role="tabpanel" aria-labelledby="pills-categories">
                                    <div className="relative">
                                        <div className="flex sm:flex-row flex-col items-center mt-1 -mx-1">
                                            <div
                                                className="relative sm:w-1/2 w-full px-1 mb-2"
                                                onClick={() => handleToggle('invoice_start_date')}

                                            >
                                                <label />
                                                <img
                                                    src="images/Iconawesome-calendar-alt.svg"
                                                    alt="icon"
                                                    className="absolute top-3 right-2.5 cursor-pointer"
                                                    onClick={() => handleToggle('invoice_start_date')}

                                                />
                                                <input
                                                    datepicker
                                                    datepicker-autohide
                                                    type="text"
                                                    className="cursor-pointer h-[38px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-xs6 font-semibold text-[#090406] px-2.5 placeholder:text-xs2 placeholder:font-normal placeholder:text-[#808285]"
                                                    placeholder="From date"
                                                    value={selected.invoice_start_date === '' ? '' : moment(selected.invoice_start_date).format('YYYY/MM/DD').split('/').reverse()
                                                        .join('/')}
                                                />
                                            </div>
                                            {toggle.invoice_start_date && <Calendar value={moment(selected.invoice_start_date).format('YYYY/MM/DD').invoice_start_date} onChange={(val) => handleDate(val, 'invoice_start_date')} placeholder="Date from" />}
                                            <div
                                                className="relative sm:w-1/2 w-full px-1 mb-2"
                                                onClick={() => handleToggle('invoice_end_date')}
                                            >
                                                <label />
                                                <img
                                                    src="images/Iconawesome-calendar-alt.svg"
                                                    alt="icon"
                                                    className="absolute top-3 right-2.5 cursor-pointer"
                                                    onClick={() => handleToggle('invoice_end_date')}
                                                />
                                                <input
                                                    datepicker
                                                    datepicker-autohide
                                                    type="text"
                                                    className="cursor-pointer h-[38px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-xs6 font-semibold text-[#090406] px-2.5 placeholder:text-xs2 placeholder:font-normal placeholder:text-[#808285]"
                                                    placeholder="To date"
                                                    value={selected.invoice_end_date === '' ? '' : moment(selected.invoice_end_date).format('YYYY/MM/DD').split('/').reverse()
                                                        .join('/')}
                                                />
                                            </div>
                                            {toggle.invoice_end_date && <Calendar value={moment(selected.invoice_end_date).format('YYYY/MM/DD').invoice_start_date} onChange={(val) => handleDate(val, 'invoice_end_date')} minDate={moment(selected.invoice_start_date).toDate()} placeholder="Date to" />}

                                        </div>
                                    </div>
                                </div>
                                <div ref={dateRef1} className={`tab-pane fade  px-3 ${selectedType === 'order_date_range' ? 'show active' : ''}`} id="pillcategorie" role="tabpanel" aria-labelledby="pills-categories">
                                    <div className="relative">
                                        <div className="flex sm:flex-row flex-col items-center mt-1 -mx-1">
                                            <div
                                                className="relative sm:w-1/2 w-full px-1 mb-2"
                                                onClick={() => handleToggle('order_start_date')}

                                            >
                                                <label />
                                                <img
                                                    src="images/Iconawesome-calendar-alt.svg"
                                                    alt="icon"
                                                    className="absolute top-3 right-2.5 cursor-pointer"
                                                    onClick={() => handleToggle('order_start_date')}

                                                />
                                                <input
                                                    datepicker
                                                    datepicker-autohide
                                                    type="text"
                                                    className="cursor-pointer h-[38px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-xs6 font-semibold text-[#090406] px-2.5 placeholder:text-xs2 placeholder:font-normal placeholder:text-[#808285]"
                                                    placeholder="From date"
                                                    value={selected.order_start_date === '' ? '' : moment(selected.order_start_date).format('YYYY/MM/DD').split('/').reverse()
                                                        .join('/')}
                                                />
                                            </div>
                                            {toggle.order_start_date && <Calendar value={moment(selected.order_start_date).format('YYYY/MM/DD').order_start_date} onChange={(val) => handleDate(val, 'order_start_date')} placeholder="Date from" />}
                                            <div
                                                className="relative sm:w-1/2 w-full px-1 mb-2"
                                                onClick={() => handleToggle('order_end_date')}
                                            >
                                                <label />
                                                <img
                                                    src="images/Iconawesome-calendar-alt.svg"
                                                    alt="icon"
                                                    className="absolute top-3 right-2.5 cursor-pointer"
                                                    onClick={() => handleToggle('order_end_date')}
                                                />
                                                <input
                                                    datepicker
                                                    datepicker-autohide
                                                    type="text"
                                                    className="cursor-pointer h-[38px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-xs6 font-semibold text-[#090406] px-2.5 placeholder:text-xs2 placeholder:font-normal placeholder:text-[#808285]"
                                                    placeholder="To date"
                                                    value={selected.order_end_date === '' ? '' : moment(selected.order_end_date).format('YYYY/MM/DD').split('/').reverse()
                                                        .join('/')}
                                                />
                                            </div>
                                            {toggle.order_end_date && <Calendar value={moment(selected.order_end_date).format('YYYY/MM/DD').order_start_date} onChange={(val) => handleDate(val, 'order_end_date')} minDate={moment(selected.order_start_date).toDate()} placeholder="Date to" />}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="flex w-full">
                            <div className="pt-3 flex justify-end w-[40%] mr-4">
                                <button
                                    type="button"
                                    className="w-full sm:h-10 h-9 border-2 border-[#555259]  bg-[#FFFFFF] rounded-lg text-sm font-semibold filter1 text-[#555259]"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={() => handleClear()}
                                >
                                    Clear Filter
                                </button>
                            </div>
                            <div className="pt-3 flex justify-end w-[70%]">
                                <button
                                    type="button"
                                    className="w-full sm:h-10 h-9 border border-[#555259] bg-[#555259] rounded-lg text-sm font-semibold apply text-[#FFFFFF]"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={() => generateUrl()}
                                >
                                    Apply Filter
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FilterModal;
